import BrandsSubscriptionsStore from '../store/schema/BrandsSubscriptionsStore';
import { BlockedSendersMap } from '../store/schema/BrandsSubscriptionsStore';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { updateBrandsSubscriptions } from '../actions/internalActions';
import { BrandSubscriptionModel } from 'owa-brands-subscription';
import { isNullOrWhiteSpace } from 'owa-string-utils';

export default mutator(updateBrandsSubscriptions, actionMessage => {
    const brandsSubscriptionsStore: BrandsSubscriptionsStore = getStore();

    // Filter the subscriptions that are from blocked senders
    brandsSubscriptionsStore.subscriptions = actionMessage.response.subscriptions.filter(
        subscriptionModel => IsValidSubscription(subscriptionModel, actionMessage.blockedSendersMap)
    );

    // Filter the unsubscribed subscriptions that are from blocked senders
    brandsSubscriptionsStore.unsubscribedSubscriptions = actionMessage.response.unsubscribedSubscriptions.filter(
        subscriptionModel => IsValidSubscription(subscriptionModel, actionMessage.blockedSendersMap)
    );
});

function IsValidSubscription(
    subscriptionModel: BrandSubscriptionModel,
    blockedSendersMap: BlockedSendersMap
): boolean {
    // We are removing subscriptions that are from blocked senders or if their display name is empty
    return (
        !blockedSendersMap[subscriptionModel.smtpInfo.smtpAddress.toLowerCase()] &&
        !isNullOrWhiteSpace(subscriptionModel.smtpInfo.displayName)
    );
}
